import React, { useState } from 'react';
import { motion } from "framer-motion";
import { FireExtinguisher } from 'lucide-react';
import { DealsRequest } from "../../requests/vendor/DealsRequest";
import { toast } from "react-toastify";

function DemoteDealModal({ setDemoteModal, dealSlug, onSuccess }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClose = () => {
    setDemoteModal({ isOpen: false, deal_slug: null });
  };

  const handleDemote = async () => {
    try {
      setIsLoading(true);
      await DealsRequest.demoteDeal(dealSlug);
      toast.success("Deal demoted successfully!");
      
      if (onSuccess) {
        await onSuccess();
      }
      
      handleClose();
    } catch (error) {
      toast.error(error.message || "Failed to demote deal. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="flex fixed inset-0 z-50 justify-center items-center backdrop-blur-sm bg-black/50"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="relative p-6 w-full max-w-md bg-white rounded-2xl shadow-xl"
      >
        <motion.div
          initial={{ rotate: 10, scale: 0 }}
          animate={{ rotate: 0, scale: 1 }}
          transition={{ type: "spring", duration: 0.5 }}
          className="flex justify-center mb-4"
        >
          <div className="p-3 bg-orange-100 rounded-full">
            <FireExtinguisher size={32} className="text-orange-500" />
          </div>
        </motion.div>

        <motion.div
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="mb-6 text-center"
        >
          <h3 className="mb-2 text-lg font-semibold text-gray-900">
            Demote Deal
          </h3>
          <p className="text-sm text-gray-500">
            Are you sure you want to demote this deal? This will reduce its visibility to customers.
          </p>
        </motion.div>

        <motion.div
          initial={{ y: 10, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="flex flex-col gap-2 sm:flex-row sm:gap-3"
        >
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleClose}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-100 rounded-xl hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
          >
            Cancel
          </motion.button>
          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={handleDemote}
            disabled={isLoading}
            className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-orange-500 to-orange-600 rounded-xl hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-orange-300 disabled:opacity-50"
          >
            {isLoading ? (
              <div className="flex justify-center items-center">
                <div className="w-5 h-5 rounded-full border-2 border-white animate-spin border-t-transparent" />
              </div>
            ) : (
              "Demote Deal"
            )}
          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
  );
}

export { DemoteDealModal };